export enum SectionType {
  Purchase = 0,
  Sell = 1,
  Settings = 2,
}
